const degreeScale = 10000000;
export default function gpsAngleToRadians(angle: number): number {
  return (Math.round(angle / degreeScale) * degreeScale + ((angle % degreeScale) * 100) / 60) / degreeScale;
}
